import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "toolbar", "helpPanel", "helpButton"]

  connect() {
    console.log("RichTextEditorController connected")
  }

  toggleHelp() {
    const panel = this.helpPanelTarget
    const button = this.helpButtonTarget
    
    if (panel.style.display === 'none' || !panel.style.display) {
      panel.style.display = 'block'
      button.textContent = 'Hide Help'
    } else {
      panel.style.display = 'none'
      button.textContent = 'Show Help'
    }
  }

  formatText(command, value = null) {
    const textarea = this.textareaTarget
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    const selectedText = textarea.value.substring(start, end)
    const beforeText = textarea.value.substring(0, start)
    const afterText = textarea.value.substring(end)

    let formattedText = ""
    let newCursorPos = start

    switch(command) {
      case "bold":
        if (selectedText) {
          formattedText = `**${selectedText}**`
          newCursorPos = start + formattedText.length
        } else {
          formattedText = "****"
          newCursorPos = start + 2
        }
        break
      case "italic":
        if (selectedText) {
          formattedText = `*${selectedText}*`
          newCursorPos = start + formattedText.length
        } else {
          formattedText = "**"
          newCursorPos = start + 1
        }
        break
      case "link":
        if (selectedText) {
          // If selected text looks like a URL, use it as the URL
          if (selectedText.match(/^https?:\/\//)) {
            formattedText = `[link text](${selectedText})`
            newCursorPos = start + 11 // Position cursor at "link text"
          } else {
            formattedText = `[${selectedText}](url)`
            newCursorPos = start + formattedText.length - 4 // Position cursor before "url"
          }
        } else {
          formattedText = "[link text](url)"
          newCursorPos = start + 11 // Position cursor at "link text"
        }
        break
    }

    textarea.value = beforeText + formattedText + afterText
    textarea.focus()
    textarea.setSelectionRange(newCursorPos, newCursorPos)
    
    // Trigger input event so any listeners know the value changed
    textarea.dispatchEvent(new Event('input', { bubbles: true }))
  }

  bold() {
    this.formatText("bold")
  }

  italic() {
    this.formatText("italic")
  }

  link() {
    this.formatText("link")
  }
}

